export const userAlertMessage = {
    UNABLE__TO_ARCHIVE_ONLY_ONE_TENANT:
        'Unable to archive the selected account.',
    UNABLE_TO_ARCHIVE_DEFAULT_ACCOUNT: `Unable to archive the only one account you have. Please contact ${process.env.CONTACT_EMAIL_ADDRESS}`,
    UNABLE_TO_DELETE_ONLY_ONE_EXISTING_ACCOUNT: `Unable to delete the only one account you have. Please contact ${process.env.CONTACT_EMAIL_ADDRESS}`,
    CONTACT_US: `Please contact ${process.env.CONTACT_EMAIL_ADDRESS}`,
    SET_OTHER_ACCOUNT_AS_ARCHIVE:
        'In order to archive it, set other account as default',
    ASK_BEFORE_DUPLICATE: 'Are you sure you want to duplicate this account?',
    ARCHIVE_ALERT:
        ' You and your team members cannot access the project linked with this account',
    ALREADY_DEFAULT_ACCOUNT: 'This account is already a default account.',
    DELETE_USER:
        'Are you sure you want to delete this user? This action is irreversible.',
    EDIT_TENANT_NAME: 'Tenant name edited successfully!',
    UNABLE_TO_EDIT_TENANT_NAME:
        'Account name already exists. Please try again!',
    UNABLE_GET_CLIENT_LIST_t:
        'Please select ${ clientTerm } name to proceed with this functionality', // use with _.template
    SWITCH_TENTANT: 'Switch account to {{ NEXXT }}.',
    UNABLE_SWITCH_TENANT:
        'Unabled to switch {{ NEXXT }} tenant. Please try again!',
    UNABLE_ARCHIVE_TENANT:
        'Could not archive {{ NEXXT }} tenant. Please try again!',
    SUCCESS_ARCHIVE_TENANT: 'Archived {{ NEXXT }} tenant.',
    SUCCESS_UPDATE_PASSWORD: 'Successfully updated password.',
    SUCCESS_INVITE_USER: 'Successfully invited user',
    UNATHORIZED_ACCESS: '{{ NEXXT }} cannot access this page.',
    SUCCESS_USER_DELETE: 'User deleted successfully!',
    SUCCESS_SEND_REMINDER: 'Successfully send reminder to the user!',
    FAIL_SEND_REMINDER:
        'Unable to send reminder to the user. Please try it again later'
};

export const authAlertMessage = {
    CODE_INVALID: `Your validation code is incorrect. Please contact ${process.env.CONTACT_EMAIL_ADDRESS}!`,
    SUCCESS_REGISTERED: 'Looking good! Now you can login.'
};

export const projectAlertMessage = {
    UNABLE_TO_ARCHIVE_DEFAULT_PROJECT: `Unable to archive the only one project you have. Please contact ${process.env.CONTACT_EMAIL_ADDRESS}`,
    ASK_PROJECT_LAUNCH:
        'Cannot access this page. Please launch the project first',
    ASK_BEFORE_ARCHIVE:
        'If you do this, all your project and the data will be removed.',
    SUCCESS_ARCHIVE_PROJECT: 'Project {{ NEXXT }} successfully archived!',
    UNABLE_ARCHIVE_PROJECT:
        'Project {{ NEXXT }} unable to archived. Please try again',
    DOWNLOAD_PROJECT_INFO: 'Do you want to download project',
    DOWNLOAD_PROJECT_INFO_SUB:
        'This action prompts downloading .xlsx file that includes questions/options in the project ',
    CONFIRM_PUBLISH:
        'Once you have launched the project, you will not be able to make any changes to the questions. You will, however, still be able to see the question/project details',
    CONFIRM_REPUBLISH:
        'This will update your live project package data with the latest changes. Would you like to continue?',
    PUBLISH_ALERT: 'Are you sure you are ready to launch?',
    REPUBLISH_ALTERT:
        'Please contact your support administrator if you are unsure of any changes made',
    UNABLE_FETCH_PROJECTS:
        'There was a problem fetching your projects. Please try again!',
    SUCCESS_DUPLIATE_PROJECT: 'Project {{ NEXXT }} successfully duplicated!',
    UNABLE_DUPLICATE_PROJECT:
        'Unable to duplicate the Project {{ NEXXT }}. Please try again later!',
    UNABLE_FETCH_PROJECT: 'Cannot find project id',
    SUCCESS_SAVE_BOTSETTINGS: 'Successfully changed bot settings',
    PROJECT_LANGUAGE_SELECTION: 'Please select language and try again!',
    PROJECT_COUNTRY_SELECTION:
        'Please select more than one country and try again!',
    PROJECT_TOPIC_SELECTION:
        'Please select more than one project topic and try again!',
    PROJECT_CLIENT_SELECTION_t: 'Please select ${ clientTerm } and try again!', // use with _.template
    PROJECT_DISQUALIFICATION_SELECTION:
        'Please select project disqualification level and try again!',
    PROJECT_DISCOURSE_SELECTION_ERROR:
        'Please select project discourse policy and try again!',
    PROJECT_CLIENT_SELECTION: 'Please select client and try again!',
    CREATE_NEW_PROJECT: 'Successfully create a new project {{ NEXXT }}',
    CREATE_NEW_CLIENT_t:
        'Please enter ${ clientTerm } name to create a new ${ clientTerm }', // use with _.template
    UPDATE_PROJECT: 'Successfully updated project {{ NEXXT }}.',

    UNABLE_LAUNCH_ERROR:
        'Please resolve the error before launch the project, MISSING fields: ',

    UNABLE_LAUNCH: 'Could not publish project. Please try again.',

    CONFIRM_PAUSE:
        'Would you like to pause the project? The survey will be disabled and you can edit the question/project details',
    PAUSE_ALERT: 'Are you sure you are ready to pause?',
    UNABLE_PAUSE: 'Unable to pause the project. Please try it again.',

    SUCCESS_DOWNLOAD_CSV: 'Successfully download csv: {{ NEXXT }}',
    DOWNLOAD_OPTION_FAIL:
        'No option data found for this project. (ERROR CODE: {{ NEXXT }}',
    DOWNLOAD_PROJECT_FAIL:
        'Could not download project information {{ NEXXT }} project. Please try again.',
    CONFIRM_CONTINUE: 'Do you want to continue this?',
    CONFIRM_DELETE_ITEM:
        'This item will be permanently deleted from this project',
    DELETE_ITEM: 'Delete the item?',
    UNDO_CURRENT_CHANGE:
        'Current changes will be ignored. Do you want to continue?',
    COPY_SUCCESS: 'Successfully copied',
    CONFIRM_DELETE_QUESTION_IN_AUDIENCE:
        'Do you want to delete this question as well? If you want to keep this question in the questionnaire, please press Keep question button.',
    CONFIRM_DELETE_DEMOGRAPHIC_QUESTION:
        'Deleting demographic question will delete audience settings as well. Do you want to continue?',
    CONFIRM_LAUNCH_REVIEW:
        'Are you sure you want to put this project in review? If you do this you will not be able to edit any of the questions.'
};

export const questionAlertMessage = {
    QUESTION_ADD_SUCCESS: 'Succesfully created question!',
    QUESTION_UPDATE_SUCCESS: 'Succesfully updated question!',
    GENERIC_ERROR_MESSAGE:
        'Sorry, something went wrong. Please refresh the page and try again.',
    QUESTION_FORM_INVALID:
        'Update failed. Please resolve all the errors and save again.',
    QUESTION_FORM_INVALID_CONTINUE:
        'It seems something might be still invalid and go wrong. Do you still want to proceed?',
    GREETING_UPDATE_SUCCESS: 'Succesfully updated greeting text!',
    QUESTION_DELETE_SUCCESS: 'Successfully deleted question {{ NEXXT }}',
    UNABLE_QUESTION_DELETE: 'Cannot delete this question type',
    QUESTION_DUPLICATE_QUESTION:
        'Successfully duplicated question {{ NEXXT }} ',
    UNABLE_SAVE_TOPICS: 'Unable to save. Currently topic has error',

    CONDITION_SAVE_SUCCESS: 'Conditions saved successfully',
    CONDITION_DELETE_SUCCESS: 'Conditions deleted successfully',

    QUOTA_SAVE_SUCCESS: 'Quota saved successfully',
    QUOTA_SAVE_SUCCESS_INCIDENCE_WARNING:
        'Please confirm custom incidence rate by clicking a price tag',
    QUOTA_SAVE_FAIL: 'Cannot save sample. Please try again later',
    AUDIENCE_RULES_SAVE:
        'Do you want to save demographics before you proceed to add a new question?',
    QUESTION_DELETE_GROUP:
        'Are you sure you want to delete this question permanently? It will delete all questions that belong to the group',
    COMPUTER_VISION_LOADING:
        'Please wait a moment as we auto detect objects from your image',
    COMPUTER_VISION_SUCCESS:
        'Successfully detected the objects from your image',
    COMPUTER_VISION_FAIL:
        'Fail to automatically detect the object from your image. Please try it again or manually define the area',
    BUTTON_ERROR: 'Please expand the options to see the missing fields',
    PAYMENT_ERROR: 'Please review your information and try it again'
};
export const optionpackAlertMessage = {
    SUCCESS_SAVE_OPTIONPACK: 'Option pack saved successfully.',
    UNABLE_SAVE_OPTIONPACK:
        'Unable to save the option pack. Please try it again.',
    DELETE_OPTIONPACK: 'Option pack deleted successfully'
};

export const checkoutAlertMessage = {
    SUCCESS_PAYMENT: 'Your payment has been successfully processed',
    CHECKOUT_FAIL: 'Please complete all the information and try it again',
    CHECKOUT_STRIPE_FAIL:
        'please contact administrator. ERROR: STRIPE load fail'
};

export const mediaAlertMessage = {
    MEDIA_DELETE_CONFIRM: 'Are you sure you want to delete this media?'
};

export const questionWarningMessage = {
    GENERIC_DISABLE_WARNING: 'Editing for this question has been disabled.',
    BUILT_IN_DISABLE_WARNING:
        'This is a built-in screening question and cannot be modified.',
    RBC_VIDEO_TEMPLATE_DISABLE_WARNING_1:
        'Editing for this question has been disabled, except that you can modify the video and question text below.',
    RBC_VIDEO_TEMPLATE_DISABLE_WARNING_2:
        'Only videos that are LESS THAN 1 minute and under 200mb are acceptable.',
    RBC_COPY_TEMPLATE_DISABLE_WARNING_1:
        'Editing for this question has been disabled, except that you can modify the message text OR upload an image.',
    RBC_COPY_TEMPLATE_DISABLE_WARNING_2:
        'Please update the content to be highlighted section. Editing is otherwise disabled.'
};

export const audienceAlertMessage = {
    CONFIRM_SWITCHING_TO_SCREENER:
        'Do you want to switch the question to screener question?',
    CONFIRM_SWITCHING_COUNTRIES:
        'Are you sure you would like to switch countries? Doing so would remove current targeting options.',
    CONFIRM_SWITCH_PANEL_SOURCING:
        'Are you sure you would like to switch your panel sourcing option? Doing so would remove current targeting options.',
    CONFIRM_SWITCH_PANEL_MULTIPLE_COUNTRIES:
        'inca panel does not support multiple countries, as a result we will only use the first country you have selected.',
    CONFIRM_SWITCH_PANEL_COUNTRY_NOT_SUPPORTED:
        'The country you have currently selected is not supported by inca Panel, as a result we will remove it from your list. Please select from our supported countries list.',
    CONFIRM_SWITCH_PANEL_COUNTRY_NOT_SUPPORTED_MULTIPLE:
        'inca panel does not support multiple countries, also some of the countries you have selected is not supported by inca Panel. As a result we will remove your selected countries. Please select from our supported countries list.'
};
export const alertMessage = {
    /** TENANT / ACCOUNT MANAGEMENT */
    ...userAlertMessage,
    ...authAlertMessage,
    /** Project / package related */
    ...projectAlertMessage,
    ...questionAlertMessage,
    ...optionpackAlertMessage,
    ...checkoutAlertMessage,
    ...audienceAlertMessage,
    ...questionWarningMessage,
    ...mediaAlertMessage
};

export const titleHeader = {
    ARCHIVE_ACCOUNT: 'Archive account',
    DEFAULT_ACCOUNT: 'Default account selected',
    DELETE_ACCOUNT: 'Delete account',
    DOWNLOAD_PROJECT_INFO: 'Download project info',
    DUPLICATE_ACCOUNT: 'Duplicate account',
    PUBLISH_LAUNCH: 'Project launch',
    PAUSE_PROJECT: 'Pause project',
    SWITCH_QUESTION_TYPE: 'Switch question type',
    SAVE_AUDIENCE_RULES: 'Save audience rules',
    REVIEW_PROJECT: 'Review Confirmation',
    SWITCH_COUNTRY: 'Switch country',
    SWITCH_PANEL_SOURCING: 'Switch panel sourcing'
};

/* @TODO: replace with _.template */
export function parseAlertMessage(msg: string, value) {
    return msg.replace('{{ NEXXT }}', value);
}
